import { Stack } from "@mui/material"
import { Typography } from "@tc/ui-dfe/components"
import { NoRequestsIcon } from "@tc/ui-dfe/icons"

export function EmptyPage() {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      gap={2}
      bgcolor="white"
      sx={{
        py: {
          xs: 6,
          md: 12,
        },
        borderRadius: 2,
      }}
    >
      <div
        style={{
          height: 80,
          width: 80,
        }}
      >
        <NoRequestsIcon
          fontSize="large"
          sx={{ height: "100%", fill: "gray", width: "100%" }}
          viewBox="0 0 70 70"
        />
      </div>
      <Typography variant="h2">No requests</Typography>
      <Typography variant="h5">{"You haven't started any requests"}</Typography>
    </Stack>
  )
}
